import React, { useState } from 'react';
import ChecklistEditorDrawer from './ChecklistEditorDrawer';

const ChecklistEditor = props => {
	const { open } = props;
	const [session, setSession] = useState(0);
	const [wasOpen, setWasOpen] = useState(open);
	// A fresh mount per open, so a reopened drawer never shows a frame of the last session's draft.
	if (open !== wasOpen) {
		setWasOpen(open);
		if (open) setSession(current => current + 1);
	}
	return <ChecklistEditorDrawer key={session} {...props} />;
};

export default ChecklistEditor;
